<template>
  <AnchorContainer class="commodity-container" @handleClick="handleCloseMask">
    <AddCommodityDrawer
      ref="addCommodityDrawer"
      :download-url="downloadUrl"
      :current-goods-info="currentGoodsInfo"
      :org-id="courseInfo.courseId"
      :org-name="courseInfo.courseName"
      @resetGoodsInfo="resetGoodsInfo"
    ></AddCommodityDrawer>
    <!-- 课程信息 -->
    <AnchorItem
      id="courseInfo"
      :name="courseInfoNameObj.name"
      :icon="courseInfoNameObj.icon"
      :icon-color="courseInfoNameObj.iconColor"
    >
      <CourseInfo
        ref="courseInfo"
        v-model="courseInfo"
        :is-copy="isCopy"
        :classroom-id="classroomId"
        :class-hour-info.sync="classHourInfo"
        :course-detail-info.sync="courseDetailInfo"
      ></CourseInfo>
    </AnchorItem>
    <!-- 课时信息 -->

    <AnchorItem
      id="classHourInfo"
      :name="classHourInfoNameObj.name"
      :icon="classHourInfoNameObj.icon"
      :icon-color="classHourInfoNameObj.iconColor"
    >
      <ClassHourInfo
        ref="classHourInfo"
        v-model="classHourInfo"
        :is-copy="isCopy"
        :org-id="courseInfo.orgId"
        :school-id="courseInfo.schoolId"
        :exsit-order="exsitOrder"
        :classroom-id="classroomId"
      ></ClassHourInfo>
    </AnchorItem>
    <!-- 课程材料 -->
    <AnchorItem
      id="materialInfo"
      :name="materialInfoNameObj.name"
      :icon="materialInfoNameObj.icon"
      :icon-color="materialInfoNameObj.iconColor"
    >
      <MaterialInfo
        ref="materialInfo"
        v-model="materialInfo"
        :course-org-id="courseOrgId"
        :exsit-order="exsitOrder"
        :classroom-id="classroomId"
        :is-copy="isCopy"
        :school-id="courseInfo.schoolId"
        :area-code="courseInfo.areaCode || areaCode"
      ></MaterialInfo>
    </AnchorItem>
    <!-- 报名设置 -->
    <AnchorItem
      id="enrollSettingInfo"
      :name="enrollSettingInfoNameObj.name"
      :icon="enrollSettingInfoNameObj.icon"
      :icon-color="enrollSettingInfoNameObj.iconColor"
    >
      <EnrollSettingInfo
        ref="enrollSettingInfo"
        v-model="enrollSettingInfo"
        :classroom-id="classroomId"
        :is-copy="isCopy"
        :school-id="courseInfo.schoolId"
        :branch-id="courseInfo.branchId"
      ></EnrollSettingInfo>
    </AnchorItem>
    <!-- 退款设置 -->
    <AnchorItem
      id="refundSettingInfo"
      :name="refundSettingInfoNameObj.name"
      :icon="refundSettingInfoNameObj.icon"
      :icon-color="refundSettingInfoNameObj.iconColor"
    >
      <RefundSettingInfo
        ref="refundSettingInfo"
        v-model="refundSettingInfo"
      ></RefundSettingInfo>
    </AnchorItem>
    <!-- 预报名设置 -->
    <!-- <AnchorItem
      id="predictionSettingInfo"
      :name="predictionSettingInfoNameObj.name"
      :icon="predictionSettingInfoNameObj.icon"
      :icon-color="predictionSettingInfoNameObj.iconColor"
    >
      <PredictionSettingInfo
        ref="predictionSettingInfo"
        v-model="predictionSettingInfo"
      ></PredictionSettingInfo>
    </AnchorItem> -->
    <!-- 其他设置 -->
    <AnchorItem
      id="otherSettingInfo"
      :name="otherSettingInfoNameObj.name"
      :icon="otherSettingInfoNameObj.icon"
      :icon-color="otherSettingInfoNameObj.iconColor"
    >
      <OtherSettingInfo
        ref="otherSettingInfo"
        v-model="otherSettingInfo"
        :course-org-id="courseOrgId"
        :course-id="courseInfo.courseId"
        :school-id="courseInfo.schoolId"
        :course-type-kind="courseInfo.courseTypeId[1]"
        :exsit-order="exsitOrder"
      ></OtherSettingInfo>
    </AnchorItem>
    <AnchorItem
      id="courseDetailInfo"
      :name="courseDetailInfoNameObj.name"
      :icon="courseDetailInfoNameObj.icon"
      :icon-color="courseDetailInfoNameObj.iconColor"
    >
      <CourseDetailInfo
        ref="courseDetailInfo"
        v-model="courseDetailInfo"
        :download-url="downloadUrl"
      ></CourseDetailInfo>
    </AnchorItem>

    <div class="formbtnbox-430-bottom">
      <Button
        type="primary"
        :loading="isSaveing && saveType === 1"
        :disabled="isSaveing && saveType !== 1"
        @click="checkAllForm(1)"
      >保存并关闭</Button>
      <Button
        type="primary"
        :loading="isSaveing && saveType === 2"
        :disabled="isSaveing && saveType !== 2"
        @click="checkAllForm(2)"
      >保存并创建同资源商品</Button>
      <Button
        type="primary"
        :loading="isSaveing && saveType === 3"
        :disabled="isSaveing && saveType !== 3"
        @click="checkAllForm(3)"
      >保存并创建其他资源商品</Button>
      <!-- <Button @click="test">取消</Button> -->

      <Button @click="handleGoBack">取消</Button>
    </div>
  </AnchorContainer>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
// 表单组件拆分start
import CourseInfo from './assets/components/CourseInfo.vue'; // 课程信息
import ClassHourInfo from './assets/components/ClassHourInfo.vue'; // 课时信息
import MaterialInfo from './assets/components/MaterialInfo.vue'; // 材料信息
import EnrollSettingInfo from './assets/components/EnrollSettingInfo.vue'; // 报名设置
import RefundSettingInfo from './assets/components/RefundSettingInfo.vue'; // 退款设置
// import PredictionSettingInfo from './assets/components/PredictionSettingInfo.vue'; // 预报名设置
import OtherSettingInfo from './assets/components/OtherSettingInfo.vue'; // 其他设置
import CourseDetailInfo from './assets/components/CourseDetailInfo.vue'; // 课程详情设置
// 表单组件拆分end
// 锚点组件start
import AnchorContainer from '@c/Anchor/AnchorContainer.vue';
import AnchorItem from '@c/Anchor/AnchorItem.vue';
// 锚点组件end
// 同资源商品抽屉组件start
import AddCommodityDrawer from './assets/components/AddCommodityDrawer.vue';
// 同资源商品抽屉组件end
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
import educationAdminApi from '@/request/educationAdmin/index.js';
import schoolAdmin from '@/request/schoolAdmin/index.js';
import {
  courseInfoForm,
  classHourInfoForm,
  materialInfoForm,
  enrollSettingInfoForm,
  refundSettingInfoForm,
  predictionSettingInfoForm,
  otherSettingInfoForm,
  courseDetailInfoForm
} from './assets/data/addCommodityPiece';
import { formatTime, getGradeMinAndMax } from '@/utils/utils';
import axios from 'axios';
export default {
  components: {
    // 表单组件start
    CourseInfo,
    ClassHourInfo,
    MaterialInfo,
    EnrollSettingInfo,
    RefundSettingInfo,
    // PredictionSettingInfo,
    OtherSettingInfo,
    CourseDetailInfo,
    // 表单组件end
    AnchorContainer,
    AnchorItem,
    AddCommodityDrawer
  },
  provide() {
    // findRuleRequireNewCourse (子组件有用到这个方法，不要删！)
    return { AddCommodityInstance: this };
  },
  data() {
    return {

      classroomId: '', // 商品Id
      courseInfo: { ...courseInfoForm }, // 课程信息
      courseInfoNameObjCopy: {},
      classHourInfo: { ...classHourInfoForm }, // 课时信息
      materialInfo: { ...materialInfoForm }, // 材料信息
      enrollSettingInfo: { ...enrollSettingInfoForm }, // 报名设置信息
      refundSettingInfo: { ...refundSettingInfoForm }, // 退款设置
      predictionSettingInfo: { ...predictionSettingInfoForm },
      otherSettingInfo: { ...otherSettingInfoForm },
      courseDetailInfo: { ...courseDetailInfoForm },

      exsitOrder: false, // 商品是否已被购买，是否存在订单
      courseInfoNameObj: {},
      classHourInfoNameObj: {},
      materialInfoNameObj: {},
      enrollSettingInfoNameObj: {},
      refundSettingInfoNameObj: {},
      // predictionSettingInfoNameObj: {},
      otherSettingInfoNameObj: {},
      courseDetailInfoNameObj: {},
      uploadToken: '',
      UploadUrl: '',
      downloadUrl: '',
      firstLoad: false,
      saveType: 1, // 1:保存并关闭 2：保存并创建同资源商品 3：保存并创建不同资源商品
      currentGoodsInfo: null,
      haveCheckForm: false,
      isSaveing: false,
      isCopy: false, // 是否是复制
      areaCode: '',
      isInitEdit: false, // 是否是刚进来进行编辑
      courseOrgId: ''
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['theUserIdentity'])
  },
  watch: {
    'courseInfo.courseId'(newVal) {
      if (newVal && !this.isInitEdit) {
        this.$nextTick(() => {
          this.getCourseDetail();
          this.$refs.materialInfo.clearCcOfferRoList();
          this.$refs.addCommodityDrawer.handleOpenDrawer();
        });
      }
    }
  },
  created() {
    this.$route.query.exsitOrder
      ? this.$route.query.exsitOrder === 'true'
        ? (this.exsitOrder = true)
        : (this.exsitOrder = false)
      : '';
    this.$route.query.copy
      ? this.$route.query.copy === '1'
        ? (this.isCopy = true)
        : (this.isCopy = false)
      : '';
    this.classroomId = this.$route.query.classroomId || '';
  },
  mounted() {
    if (this.theUserIdentity === 'school') {
      this.courseInfo.schoolId = this.userInfo.orgId;
      this.courseInfo.schoolName = this.userInfo.orgName;
      this.courseInfo.areaCode = this.userInfo.areaCode;
    }
    this.getUploadtoken();
    if (this.classroomId) {
      // this.getUploadtoken();
      this.isInitEdit = true;
      this.getClassRoomDetail();
      return;
    } else {
      const datestr = formatTime(Date.now(), 'yyyy-MM-dd hh:mm:ss');
      console.log(datestr, '64546=========');
      this.$set(this.enrollSettingInfo, 'enrollTimeBegin', datestr);
      this.$set(this.enrollSettingInfo, 'enrollTimeBeginShow', datestr);
    }
    const { schoolId, schoolName, courseId } = this.$route.query;
    if (schoolId && schoolName && courseId) {
      this.courseInfo.schoolId = schoolId;
      this.courseInfo.schoolName = schoolName;
      this.courseInfo.courseId = courseId;
      this.$nextTick(() => {
        this.$refs.addCommodityDrawer.handleOpenDrawer();
      });
    }
  },
  methods: {
    ...mapMutations(['setCheckStuListStore', 'CLOSE_BROWSINGHISTORYLIST', 'DELETE_CACHEROUTE']),
    handleCloseMask() {
      // console.log('点击了-------');
      this.$nextTick(() => {
        this.$refs.addCommodityDrawer.handleCloseDrawer();
      });
    },
    resetGoodsInfo() {
      this.getClassRoomDetail();
    },
    async getSchoolDetailBySchFunc(orgId) {
      return new Promise(async(resolve, reject) => {
        const params = {
          orgId
        };
        try {
          const res = await schoolAdmin.getSchoolDetailNew(params);
          if (res.status === 200) {
            resolve(res.message.baseInfo.name);
          } else {
            reject(false);
          }
        } catch (err) {
          reject(false);
        }
      });
    },
    // 点击编辑时，获取课程商品详情
    async getClassRoomDetail() {
      const res = await courseCenterApi.getCourseClassDtl({
        classroomId: this.classroomId
      });
      if (res.status === 200) {
        this.courseInfo = this.fillKeyValue(this.courseInfo, res.message);
        this.getSchoolAreaCode(this.courseInfo.schoolId);

        this.courseInfo.branchId = res.message.courseClassExtVO.schBranchId;
        this.courseInfo.courseTypeId = res.message.courseTypeString.split(',');
        this.courseInfo.courseChannel = '' + res.message.courseChannel;
        this.$refs.courseInfo.hangingRuleIdInfo = this.courseInfo.courseChannel === '1' && res.message.hangingInfo ? {
          ruleId: res.message.hangingInfo.ruleId,
          ruleName: res.message.hangingInfo.ruleName
        } : {};
        this.courseOrgId = res.message.orgId;

        this.$refs.courseInfo.setTerm();
        this.$refs.courseInfo.selectSchoolData = {
          name: this.courseInfo.schoolName,
          id: this.courseInfo.schoolId,
          orgId: this.courseInfo.schoolId
        };
        this.firstLoad = true;

        this.classHourInfo = this.fillKeyValue(this.classHourInfo, res.message);
        this.classHourInfo.isHideClasstime = String(res.message.courseClassExtVO.isHideClasstime);
        this.classHourInfo.isHideClasstimeTail = String(res.message.courseClassExtVO.isHideClasstimeTail);
        this.classHourInfo.arrangingRuleBo =
          res.message.courseClassExtVO.arrangingRuleBo;
        this.classHourInfo.reqRoomCount =
          res.message.courseClassExtVO.reqRoomCount;
        this.classHourInfo.classroomTotal = res.message.classroomTotal + '';
        this.classHourInfo.fee = res.message.classroomFee / 100 + '';
        this.classHourInfo.feeShow = this.classHourInfo.fee;
        this.classHourInfo.courseDisplayPrice = res.message.courseClassExtVO.courseDisplayPrice || res.message.courseClassExtVO.courseDisplayPrice === 0 ? res.message.courseClassExtVO.courseDisplayPrice / 100 + '' : '';
        this.classHourInfo.courseDisplayPriceShow = this.classHourInfo.courseDisplayPrice;
        this.classHourInfo = { ...this.classHourInfo, ...getGradeMinAndMax(res.message.gradeMin, res.message.gradeMax) };
        this.materialInfo.addCourseClassMaterialRoList = res.message.courseClassMaterialVoList.map(item => {
          return {
            offerPrice: Number(item.offerPrice) / 100,
            offerName: item.offerName,
            materialDisplayPrice: item.materialDisplayPrice === null || item.materialDisplayPrice === '' || item.materialDisplayPrice === undefined ? null : Number(item.materialDisplayPrice) / 100,
            divideConfigId: item.divideConfigId,
            materialId: item.materialId,
            accountingNum: item.accountingNum,
            reqMaterialType: +item.reqMaterialType === 1
          };
        });
        this.$refs.materialInfo.setCcOfferRoList(this.materialInfo.addCourseClassMaterialRoList);
        try {
          this.$refs.classHourInfo.begin = res.message.classDateBegin;
          this.$refs.classHourInfo.end = res.message.classDateEnd;
          this.$refs.classHourInfo.arrangingRuleTag = 1;
          this.$refs.classHourInfo.fillTimeList();
        } catch (err) {
          // console.log(err, '==========');
        }
        this.$refs.classHourInfo.teacherList = res.message.teacherList.map(
          (item) => {
            console.log(item, '拿到的---42432');
            item.userId = item.teacherId;
            item.userName = item.teacherName;
            return item;
          }
        );

        this.classHourInfo.teacherIds = res.message.teacherList.map(item => item.teacherId);

        this.materialInfo = this.fillKeyValue(this.materialInfo, res.message);
        this.materialInfo.attachmentPriceShow =
          this.materialInfo.attachmentPrice / 100 + '';

        this.enrollSettingInfo = this.fillKeyValue(
          this.enrollSettingInfo,
          res.message
        );
        this.enrollSettingInfo.enrollTimeBeginShow = this.enrollSettingInfo.enrollTimeBegin;
        this.enrollSettingInfo.enrollTimeEndShow = this.enrollSettingInfo.enrollTimeEnd;
        if (res.message.visibleStuDTOList) {
          const stuArr = JSON.parse(
            JSON.stringify(res.message.visibleStuDTOList)
          );
          this.$refs.enrollSettingInfo.stuIdsShowList = [];
          this.$refs.enrollSettingInfo.studentList = [];
          this.$refs.enrollSettingInfo.stuIdsList = [];
          for (let i = 0; i < stuArr.length; i++) {
            stuArr[i]['id'] = stuArr[i].userId;
            stuArr[i]['studentId'] = stuArr[i].userId;
            stuArr[i]['studentName'] = stuArr[i].userName;
            const obj = {
              value: stuArr[i].userId,
              label: `${stuArr[i].userName}（${stuArr[i].gradeName}${stuArr[i].className}）`
            };
            if (i < 5) {
              this.$refs.enrollSettingInfo.stuIdsShowList.push(obj);
            }
            this.$refs.enrollSettingInfo.studentList.push(stuArr[i]);
          }
          this.setCheckStuListStore(this.$refs.enrollSettingInfo.stuIdsList);
        }
        if (res.message.isLimitEnroll === 2) {
          this.enrollSettingInfo.visibleDTOList = [];
          this.enrollSettingInfo.visibleStuDTOList =
            res.message.visibleStuDTOList;
          this.enrollSettingInfo.stuIds = res.message.visibleStuDTOList.map(
            item => {
              return item.userId;
            }
          );
        }

        this.refundSettingInfo = this.fillKeyValue(
          this.refundSettingInfo,
          res.message.courseClassExtVO
        );
        this.refundSettingInfo.refundDeadlineShow = this.refundSettingInfo.refundDeadline;
        if (this.refundSettingInfo.refundDeadline === '2099-01-01 00:00:00') {
          this.$refs.refundSettingInfo.timeLimitStu = 1;
          this.refundSettingInfo.refundDeadline = '';
          this.refundSettingInfo.refundDeadlineShow = '';
        } else {
          this.$refs.refundSettingInfo.timeLimitStu = 1;
        }

        // this.predictionSettingInfo = {
        //   isPreEnroll: res.message.courseClassExtVO.isPreEnroll
        // };
        this.otherSettingInfo = {
          visibleType: res.message.courseClassExtVO.visibleType !== 1 && res.message.courseClassExtVO.visibleType !== 0 ? '' : res.message.courseClassExtVO.visibleType,
          classroomState: res.message.classroomState,
          itemId: res.message.itemId
        };

        this.courseDetailInfo = this.fillKeyValue(
          this.courseDetailInfo,
          res.message.courseClassExtVO
        );
        if (
          this.courseDetailInfo.courseCover &&
          this.courseDetailInfo.courseCover !== '0'
        ) {
          const imgObj = {
            fileId: this.courseDetailInfo.courseCover,
            file: null,
            imgShow: ''
          };
          this.$set(this.courseDetailInfo, 'courseCoverShow', imgObj);
        }
        this.courseDetailInfo.courseAchievementShow = this.courseDetailInfo
          .courseAchievement
          ? this.courseDetailInfo.courseAchievement.split(',').map(item => {
            return {
              fileId: item,
              file: null,
              imgShow: ''
            };
          })
          : [];
        this.$refs.courseDetailInfo.fillEditor(this.courseDetailInfo.context);
        console.log('详情', this.courseInfo);
        this.currentGoodsInfo = {
          courseCover: this.courseDetailInfo.courseCover,
          classroomId: this.classroomId,
          classroomName: this.courseInfo.classroomName,
          orgName: res.message.orgName,
          schoolName: res.message.schoolName,
          classroomFee: res.message.classroomFee,
          courseEnrollState: ''
        };

        this.$nextTick(() => {
          this.$refs.materialInfo.getLedgerRules();
          this.$refs.courseInfo.checkForm();
          this.$refs.classHourInfo.checkForm();
          this.$refs.materialInfo.checkForm();
          this.$refs.enrollSettingInfo.checkForm();
          this.$refs.refundSettingInfo.checkForm();
          // this.$refs.predictionSettingInfo.checkForm();
          this.$refs.otherSettingInfo.checkForm();
          this.$refs.courseDetailInfo.checkForm();
        });
        this.$nextTick(() => {
          this.isInitEdit = false;
        });
        try {
          this.courseInfo.schoolName = await this.getSchoolDetailBySchFunc(this.courseInfo.schoolId);
          console.log(this.courseInfo.schoolName, '拿到的---32');
        } catch (err) {
          console.log(err);
        }
      }
    },
    // 获取学校的aracode
    async getSchoolAreaCode(schoolId) {
      const params = {
        eduId: schoolId
      };
      const res = await educationAdminApi.getEduAreaName(params);
      if (res.status === 200) {
        if (
          process.env.NODE_ENV === 'production' &&
          (schoolId === '681611867042402304' ||
            schoolId === '614867741949562880' ||
            schoolId === '701006079886184448')
        ) {
          this.areaCode = '440114';
        } else {
          this.areaCode = res.message.areaCode;
        }
      }
    },
    fillKeyValue(target, value) {
      Object.keys(target).forEach(item => {
        if (value[item]) {
          target[item] = value[item];
        }
      });
      return target;
    },
    // 获取图片下载地址
    getImgsrc(id) {
      return `${this.downloadUrl}?fileId=${id}`;
    },
    // 上传token
    async getUploadtoken() {
      return new Promise((resolve, reject) => {
        this.$http.getUploadtoken().then(res => {
          this.uploadToken = res.message.token;
          this.UploadUrl = res.message.upUrl;
          this.downloadUrl = res.message.downUrl;
          resolve(res);
        });
      });
    },
    findRuleRequireNewCourse(context, tag, name) {
      // 拿到必填的项
      const requireKeys = Object.keys(context[`${tag}Required`]).filter(
        item => {
          return (
            context[`${tag}Required`][item] &&
            context[`${tag}Required`][item].require
          );
        }
      );
      console.log('拿到必填---', requireKeys);
      // 拿到必填项已填了多少个
      let fillLength = 0;
      requireKeys.forEach(item => {
        if (context[`${tag}Required`][item]) {
          context[`${tag}Required`][item].status ? (fillLength += 1) : '';
        }
      });
      const hasFinished = requireKeys.length === fillLength;
      // 表单所有要填写的项目是否都已填写正确
      const formTag = Object.keys(context[`${tag}Required`]).every(item => {
        return context[`${tag}Required`][item].status;
      });
      this[`${tag}NameObj`] = {
        name: `${name} （${fillLength} / ${requireKeys.length}）`,
        icon:
          !formTag && this.haveCheckForm
            ? 'ios-alert'
            : hasFinished
              ? 'md-checkmark-circle'
              : '',
        iconColor:
          !formTag && this.haveCheckForm
            ? '#ed4014'
            : hasFinished
              ? '#19be6b'
              : '',
        formTag
      };
    },
    getInfo(e, tag) {
      this[tag] = e;
    },
    // 校验全部的表单
    async checkAllForm(saveType) {
      this.isSaveing = true;
      this.haveCheckForm = true;
      this.saveType = saveType;
      this.$refs.courseInfo.checkForm();
      this.$refs.classHourInfo.checkForm();
      this.$refs.materialInfo.checkForm();
      this.$refs.enrollSettingInfo.checkForm();
      this.$refs.refundSettingInfo.checkForm();
      // this.$refs.predictionSettingInfo.checkForm();
      this.$refs.otherSettingInfo.checkForm();
      await this.$refs.courseDetailInfo.checkForm();
      const tag = this.checkAllRule();
      if (tag) {
        this.submitForm();
      } else {
        this.isSaveing = false;
      }
    },
    checkAllRule() {
      if (
        this.courseInfoNameObj.formTag &&
        this.classHourInfoNameObj.formTag &&
        this.materialInfoNameObj.formTag &&
        this.enrollSettingInfoNameObj.formTag &&
        this.refundSettingInfoNameObj.formTag &&
        // this.predictionSettingInfoNameObj.formTag &&
        this.otherSettingInfoNameObj.formTag &&
        this.courseDetailInfoNameObj.formTag
      ) {
        return true;
      } else {
        return false;
      }
    },
    // 取消返回上一页
    handleGoBack() {
      this.$router.push({
        path: `/courseCenter/commodity/CommodityTable`
      });
    },
    async submitForm() {
      try {
        const formValidate = {};
        const courseClassExtAddRO = {};
        const {
          arrangingRuleBo,
          reqRoomCount,
          gradeMin,
          gradeMax,
          courseDisplayPrice,
          ...otherClassHourInfo
        } = this.classHourInfo;
        console.log(this.predictionSettingInfo, '预报名信息是-----');
        const { visibleType, classroomState, itemId } = this.otherSettingInfo;
        Object.assign(
          courseClassExtAddRO,
          { payBeginTime: '', payDeadline: '', classroomTimeDesc: '' },
          { arrangingRuleBo },
          { reqRoomCount },
          { visibleType },
          this.refundSettingInfo,
          this.predictionSettingInfo,
          this.courseDetailInfo,
          { courseDisplayPrice }
        );
        courseClassExtAddRO.schBranchId = this.courseInfo.branchId;

        Object.assign(
          formValidate,
          this.courseInfo,
          otherClassHourInfo,
          {
            gradeMin: gradeMax > gradeMin ? gradeMin : gradeMax,
            gradeMax: gradeMax > gradeMin ? gradeMax : gradeMin
          },
          this.materialInfo,
          this.enrollSettingInfo,
          { classroomState },
          { itemId }
        );

        if (courseClassExtAddRO.courseCoverShow) {
          courseClassExtAddRO.courseCover = await this.uploadImg(
            courseClassExtAddRO.courseCoverShow
          );
        } else {
          courseClassExtAddRO.courseCover = '0';
        }
        if (courseClassExtAddRO.courseAchievementShow.length > 0) {
          const arr = [];
          for (const key in courseClassExtAddRO.courseAchievementShow) {
            arr.push(
              await this.uploadImg(
                courseClassExtAddRO.courseAchievementShow[key]
              )
            );
          }
          courseClassExtAddRO.courseAchievement = arr.join();
        } else {
          courseClassExtAddRO.courseAchievement = '';
        }
        formValidate.studentTotal ? '' : (formValidate.studentTotal = 0);
        // console.log(formValidate, '商品信息0--32------');
        // return;
        courseClassExtAddRO.isHideClasstime = this.classHourInfo.isHideClasstime;
        courseClassExtAddRO.isHideClasstimeTail = this.classHourInfo.isHideClasstimeTail;
        console.log('---------------');
        console.log(visibleType, formValidate, formValidate.visibleDTOList);
        // if (+visibleType === 2) {
        //   if (formValidate.visibleDTOList.length === 0 && (!formValidate.stuIds || formValidate.stuIds.length === 0)) {
        //     this.$Message.warning('请选择圈定报名范围～');
        //     this.isSaveing = false;
        //     return null;
        //   }
        // }

        if (this.classroomId && !this.isCopy) {
          formValidate.courseClassExtUpdateRO = courseClassExtAddRO;
          formValidate.courseClassExtUpdateRO.classroomId = this.classroomId;
          formValidate.updateCourseClassMaterialBoList = formValidate.addCourseClassMaterialRoList;
          delete formValidate.addCourseClassMaterialRoList;
          // formValidate.visibleDTOList = formValidate.visibleDTOList.map(item => {
          //   const { visibleId, ...obj } = item;
          //   return obj;
          // });
          delete formValidate.isHideClasstime;
          delete formValidate.isHideClasstimeTail;
          this.handleToEdit(formValidate);
        } else {
          formValidate.courseClassExtAddRO = courseClassExtAddRO;

          // formValidate.visibleDTOList = formValidate.visibleDTOList.map(item => {
          //   const { visibleId, classroomId, ...obj } = item;
          //   return obj;
          // });
          delete formValidate.isHideClasstime;
          delete formValidate.isHideClasstimeTail;
          this.handleToPut(formValidate);
        }
      } catch (err) {
        this.isSaveing = false;
      }
    },
    async uploadImg(fileObj) {
      if (fileObj.fileId) {
        return fileObj.fileId;
      }
      return new Promise(async(resolve, reject) => {
        const file = fileObj.file;
        const formData = new FormData();
        const r = await this.getUploadtoken();
        const obj = { token: '', upUrl: '', downUrl: '' };
        if (r.status === 200) {
          Object.assign(obj, r.message);
        }

        formData.append('token', obj.token);
        formData.append('file', file);
        const token = localStorage.getItem('loginToken');
        var configs = {
          // 上传文件 请求头要设置成下面这样
          headers: {
            token: token,
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        axios.post(obj.upUrl, formData, configs).then(res => {
          if (res.data.status === 200) {
            const id = res.data.message.fileId;
            resolve(id);
          } else {
            this.$Message.warning(res.data.error);
          }
        });
      });
    },
    // 提交 新增课程
    async handleToPut(formValidate) {
      const params = JSON.parse(JSON.stringify(formValidate));
      params.courseTypeId = formValidate.courseTypeId[2];
      delete params.courseClassExtAddRO.courseCoverShow;
      delete params.courseClassExtAddRO.courseAchievementShow;
      // console.log('拿到的入参00000-=-=', params);
      // return;
      // params.classroomName = this.formValidate.classroomName.trim();
      this.$Spin.show();
      try {
        const res = await courseCenterApi.addcourse(params);
        if (res.status === 200) {
          this.$Message.success('添加成功!');
          this.afterSave();
        } else {
          this.isSaveing = false;
        }
      } catch (err) {
        this.isSaveing = false;
      } finally {
        this.$Spin.hide();
      }
    },
    // 修改
    async handleToEdit(formValidate) {
      // this.formValidate.courseClassExtUpdateRO =
      //   this.formValidate.courseClassExtAddRO;
      const params = JSON.parse(JSON.stringify(formValidate));
      params.courseTypeId = formValidate.courseTypeId[2];
      params.classroomId = this.classroomId;
      delete params.courseClassExtUpdateRO.courseCoverShow;
      delete params.courseClassExtUpdateRO.courseAchievementShow;
      // params.classroomName = this.formValidate.classroomName.trim();
      this.$Spin.show();
      try {
        const res = await courseCenterApi.editCourse(params);
        if (res.status === 200) {
          this.$Message.success('修改成功!');
          this.afterSave();
        } else {
          this.isSaveing = false;
        }
      } catch (err) {
        this.isSaveing = false;
        // console.log('err', err);
      } finally {
        this.$Spin.hide();
      }
    },
    resetForm() {
      this.courseInfo = { ...courseInfoForm }; // 课程信息
      this.classHourInfo = { ...classHourInfoForm }; // 课时信息
      this.materialInfo = { ...materialInfoForm }; // 材料信息
      this.enrollSettingInfo = { ...enrollSettingInfoForm }; // 报名设置信息
      this.refundSettingInfo = { ...refundSettingInfoForm }; // 退款设置
      // this.predictionSettingInfo = { ...predictionSettingInfoForm };
      this.otherSettingInfo = { ...otherSettingInfoForm };
      this.courseDetailInfo = { ...courseDetailInfoForm };
    },
    test() {
      const obj = {
        schoolId: this.courseInfo.schoolId,
        schoolName: this.courseInfo.schoolName,
        courseId: this.courseInfo.courseId
      };
      this.$router.push({
        name: `courseCenter_commodity_addCommodity_empty`,
        query: {
          routerName: 'courseCenter_commodity_addCommodity_addCommodity',
          queryObj: JSON.stringify(obj)
        }
      });
    },
    // 保存成功之后
    afterSave() {
      const obj = {
        schoolId: this.courseInfo.schoolId,
        schoolName: this.courseInfo.schoolName,
        courseId: this.courseInfo.courseId
      };
      this.CLOSE_BROWSINGHISTORYLIST(this.$route.name);
      // 新增
      if (!(this.classroomId && !this.isCopy)) {
        this.DELETE_CACHEROUTE('CommodityTable');
      }
      switch (this.saveType) {
        case 1:
          this.$router.push({
            path: `/courseCenter/commodity/CommodityTable`
          });
          break;
        case 2:
          this.$router.push({
            name: `courseCenter_commodity_addCommodity_empty`,
            query: {
              routerName: 'courseCenter_commodity_addCommodity_addCommodity',
              queryObj: JSON.stringify(obj)
            }
          });
          break;
        case 3:
          this.$router.push({
            name: `courseCenter_commodity_addCommodity_empty`,
            query: {
              routerName: 'courseCenter_commodity_addCommodity_addCommodity'
            }
          });
          break;
      }
      this.isSaveing = false;
    },
    async getCourseDetail() {
      const res = await courseCenterApi.getCourseDetail({
        courseId: this.courseInfo.courseId
      });
      if (res.status === 200) {
        this.courseOrgId = res.message.orgId;
        console.log(this.courseOrgId, res.message.orgId, '拿到的---42332getCourseDetail');
        this.$nextTick(() => {
          this.$refs.materialInfo.getLedgerRules();
        });
      }
    }
    //

  }
};
</script>
<style lang="scss" scoped>
.commodity-container {
  padding-bottom: 80px;
}
.formbtnbox-430-bottom {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1000;
  left: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-shadow: 0 -4px 2px rgba(0, 0, 0, 0.03);
  padding: 16px 0;

  button + button {
    margin-left: 16px;
  }
}
</style>
